module.exports = __webpack_public_path__ + "static/img/pp.e54216b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pp.jpg
// module id = yrtD
// module chunks = 0